<template>
	<div class="position-absolute d-flex" style="top: 0; justify-content: space-between">
		<!-- 저장 -->
		<sf-button v-if="isButton_(scrId, 'CC')" size="sm" line icon="file" :onClick="saveAction">
			{{ getMessage_('QWCC001131') }}
		</sf-button>
		<!--  신규 -->
		<sf-button v-if="isButton_(scrId, 'CU')" size="sm" line icon="sub-menu-off" :onClick="addRow">
			{{ getMessage_('QWCC001083') }}
		</sf-button>
	</div>
</template>

<script>
import _ from 'lodash';
import * as Yup from 'yup';
import { SELECTED_ROW } from '../../store/state';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schemaSave() {
			return Yup.object().shape({
				ckuLgrpCd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001122')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001122')])),
				// ipnWayCd: Yup.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001213')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001213')])),
				// icrtCd: Yup.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001243')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001243')])),
				useYn: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001163')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001163')])),
				ipnPrvsSbc: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001215')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001215')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		addRow() {
			this.setRowInit_();
			this.setState_({ key: 'oldSelectedRow', value: SELECTED_ROW() });
			this.setState_({ key: 'isNew', value: true });
		},
		saveAction() {
			try {
				this.schemaSave.validateSync(this.selectedRow);
				if (this.sgrpList.length && !this.selectedRow.ckuSgrpCd) {
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001123')]));
				}
				if (this.selectedRow.creDataScnCd === 'Q' && !this.selectedRow.ipnWayCd) {
					// 배치에서 넘어온 정보가 아니고, 방식을 입력하지 않았을 때 에러
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001213')]));
				}
				if (Number(this.selectedRow.minVal) > Number(this.selectedRow.maxVal)) {
					throw new Error(this.getMessage_('QWCC001970')); //최소값(Min)은 최대값(Max)보다 클 수 없습니다.
				}
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001119'),
					buttons: [{ title: 'Ok', clickFn: this.save }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async save() {
			try {
				this.$sf_toggleLoading(true);
				if (this.isNew) {
					this.setSelectedRow_({ key: 'lgrpCd', value: this.selectedRow.ckuLgrpCd });
					this.setSelectedRow_({ key: 'sgrpCd', value: this.selectedRow.ckuSgrpCd });
				}
				const {
					header: { code, messageCd },
					body
				} = await this.saveData_(this.selectedRowData_);
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					if (code === 0) {
						this.setState_({ key: 'selectedRow', value: body });
						this.refresh();
					}
				}
				if (code === 2) {
					// 중복건 발생
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.getMessage_(messageCd), //중복건이 존재합니다. 계속진행하시겠습니까?
						buttons: [{ title: this.getMessage_('QWCC001969'), clickFn: () => this.getDupCase(body) }] //진행할 경우
					});
				}
			} catch (error) {
				console.error(error);
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') }); //저장에 실패
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		//중복 건 동의 후 가져오기
		getDupCase(requestBody) {
			const { resultList } = requestBody;
			resultList && this.setState_({ key: 'selectedRow', value: resultList[0] });
			this.setState_({ key: 'isNew', value: false });
		},
		/** 저장 후 새로고침 */
		async refresh() {
			this.isLoaded = false;
			this.$sf_toggleLoading(true);
			try {
				await this.getList_();
				this.setRowInit_();
				this.setState_({ key: 'oldSelectedRow', value: SELECTED_ROW() });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
				this.isLoaded = true;
			}
		}
	}
};
</script>

<style lang="scss" scoped></style>
